export const UNIFIED_WITHDRAW_FORM_PT_BR = {
	drawerTitle: "Saque & Transferência",
	steps: {
		information: "Informações dos dados",
		review: "Revisão dos dados",
	},
	totalBalance: "Saldo Total",
	sendTo: "Enviar para",
	sendToPlaceholder: "Digite ou Selecione a conta",
	addNewAccount: "+ Adicionar nova Conta",
	defaultAccountBadge: "Conta padrão",
	liquidValue: "Valor Líquido",
	liquidValuePlaceholder: "R$ 0,00",
	reason: "Motivo da Solicitação",
	reasonPlaceholder: "Digite o motivo para saque",
	goBack: "Voltar",
	goForward: "Avançar",
	submit: "Solicitar Saque",
	errorMessage: "Não foi possível processar sua solicitação. Tente novamente.",
	successMessage: "Sua solicitação de saque foi enviada com sucesso!",
	splitBar: {
		available: "Disponível",
		anticipation: "Antecipação",
	},
	totalChipSuffix: "(total)",
	anticipationFee: "Taxa de antecipação",
	thirdPartyFee: "Taxa para conta de terceiro",
	feeError: {
		message: "Não foi possível consultar a taxa de antecipação. Tente novamente.",
		retry: "Tentar novamente",
	},
	review: {
		valuesReview: "Revisão dos Valores",
		typeLabel: "Tipo",
		typeWithdraw: "Saque",
		typeWithdrawAndAnticipation: "Saque + Antecipação",
		statusLabel: "Status",
		statusPending: "A processar",
		requestedValue: "Valor solicitado",
		anticipatedValue: "Valor antecipado",
		thirdPartyFeeLabel: "Taxa para conta de terceiro",
		anticipationFeeLabel: "Taxa de antecipação",
		anticipationFeeOnThirdPartyLabel: "Taxa de antecipação sobre taxa de terceiro",
		grossValue: "Valor Bruto",
		grossValueAnticipation: "Valor Bruto a antecipar",
		attentionBannerTitle: "Atenção",
		attentionBannerMessage:
			"Solicitações realizadas após as 10:30h (horário de Brasília) só serão atendidas no dia seguinte.",
		bankDataTitle: "Dados Bancários",
		holderLabel: "Titular da Conta",
		accountTypeLabel: "Tipo de Conta",
		agencyLabel: "Agência",
		accountNumberLabel: "Conta",
		pixKeyLabel: "Chave PIX",
	},
	completion: {
		title: "Tudo certo!",
		description:
			"O valor solicitado para saque está sendo processado pelo time Financeiro.",
	},
	partialFailure: {
		modalTitle: "Saque parcialmente processado",
		modalDescription:
			"O saque do saldo foi realizado, mas a antecipação não pôde ser concluída.",
		title: "Antecipação não concluída",
		message:
			"O saque do saldo foi realizado, mas a antecipação falhou. Tente novamente apenas a antecipação.",
		notification:
			"Saque do saldo realizado, mas a antecipação falhou. Tente novamente apenas a antecipação.",
	},
};

export type UnifiedWithdrawFormTranslations = typeof UNIFIED_WITHDRAW_FORM_PT_BR;
